import React from 'react';
import { useLocation, useNavigate } from 'react-router';

import { UI_ROUTES } from '../../util/routes';

import ErrorAddBankAccount from './Wallet/ErrorAddBankAccount/ErrorAddBankAccount';
import ErrorWalletPage from './Wallet/ErrorWalletPage/ErrorWalletPage';

const Error = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { target } = location.state as { target: string };

  return (
    <>
      {target === UI_ROUTES.funds && <ErrorWalletPage />}
      {target === `${UI_ROUTES.funds}${UI_ROUTES.uploadBankStatement}` && <ErrorAddBankAccount />}
    </>
  );
};
export default Error;
